(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
if (!customElements.get("s-search-modal")) {
  customElements.define(
    "s-search-modal",
    class SectionSearchModal extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.sectionId = this.dataset.sectionId;
        this.body = document.querySelector("body");
        this.overlay = document.querySelector(".js-overlay");

        this.inputSearch = this.querySelector(".js-search-modal__search-input");
        this.resultsWrapper = this.querySelector(".js-search-modal__wrapper");

        
        this.resizeHandler();

        
        this.modalCloseUnsubscriber = window.PubSub.subscribe('search-modal:close', this.closerModal);
        this.modalCloseUnsubscriber = window.PubSub.subscribe('search-modal:open', this.openerModal.bind(this, ));
        
        if (this.inputSearch) {
          const debounceApiDataRequest = debounce(() => {
            this.renderSearchWrapper();
          }, 300);

          this.inputSearch.addEventListener(
            "input",
            debounceApiDataRequest.bind(this)
          );
        }
        window.addEventListener("resize", this.resizeHandler);
      }

      disconnectedCallback() {
       let tabItems = Array.from(this.resultsWrapper.querySelectorAll(".js-search-modal__tabs-item"));

        tabItems.forEach(item => {
          item.removeEventListener("click", this.changeActiveTab.bind(this, item))
        })

        window.removeEventListener("resize", this.resizeHandler);
        this.overlay.removeEventListener("click", this.closerModal)
      }

      renderSearchWrapper = async(q = this.inputSearch.value) => {
        if (q == "" && window.innerWidth >= 992) {
          this.closerModal();
          this.resultsWrapper.innerHTML = "";

          return
        }
        
        let query = q;

        await this.searchResults(query);

        let firstTabItem = this.resultsWrapper.querySelector(".js-search-modal__tabs-item");
        if (firstTabItem) {
          this.changeActiveTab(firstTabItem);

          let tabItems = Array.from(this.resultsWrapper.querySelectorAll(".js-search-modal__tabs-item"));

          tabItems.forEach(item => {
            item.addEventListener("click", this.changeActiveTab.bind(this, item))
          })
        }
      }

      changeActiveTab = (tabItem) => {
        let tabItems = Array.from(this.resultsWrapper.querySelectorAll(".js-search-modal__tabs-item"));
        let tabs = Array.from(this.resultsWrapper.querySelectorAll(".js-search-modal__tab"));
        let links = Array.from(this.resultsWrapper.querySelectorAll(".js-search-modal__link-wrapper"));

        tabItems.forEach(item => {
          item.classList.remove("is-active")
        })

        tabs.forEach(tab => {
          tab.classList.remove("is-active")
        })

        links.forEach(link => {
          link.classList.remove("is-active")
        })

        let tabName = tabItem.dataset.type;
        let firstTab = this.resultsWrapper.querySelector(`.js-search-modal__tab[data-type='${tabName}']`);
        let firstLink = this.resultsWrapper.querySelector(`.js-search-modal__link-wrapper[data-type='${tabName}']`);
        tabItem.classList.add("is-active");
        firstTab.classList.add("is-active");
        firstLink.classList.add("is-active");
      }

      searchResults = async (q) => {
        var requestResponse;

        await fetch(window.Shopify.routes.root + `search/suggest?q=${q}&resources[limit]=20&resources[type]=article,query,product,page&section_id=${this.sectionId}`)
          .then((response) => {
            requestResponse = response;
            return response.text();
          })
          .then((text) => {
            if (!requestResponse.ok) {
              this.resultsWrapper.innerHTML = ""
              throw new Error(`${requestResponse.status}: ${text}`);
            }

            const resultsMarkup = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.js-search-modal__wrapper').innerHTML;

            this.resultsWrapper.innerHTML = resultsMarkup
          })
          .catch((error) => {
            console.error(error);
            this.resultsWrapper.innerHTML = ""
          });
      }

      closerModal = () => {
        this.body.classList.remove("modal-open");
        this.overlay.classList.remove("is-open");
        this.classList.remove("is-open");

        this.overlay.removeEventListener("click", this.closerModal)
      }

      openerModal = (q) => {
        this.body.classList.add("modal-open");
        this.overlay.classList.add("is-open");
        this.classList.add("is-open");
        this.resizeHandler();
        this.renderSearchWrapper(q);

        this.overlay.addEventListener("click", this.closerModal)
      }

      resizeHandler = () => {
        let header = document.querySelector(".section-header");
        let announcementBar = document.querySelector(".section-announcement-bar");

        let space = 0
        
        let rect = announcementBar.getBoundingClientRect();
        let windowHeight = window.innerHeight || document.documentElement.clientHeight;
        let windowWidth = window.innerWidth || document.documentElement.clientWidth;

        let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);
        let visibleWidth = Math.min(rect.right, windowWidth) - Math.max(rect.left, 0);

        let areaVisible = Math.max(0, visibleHeight) * Math.max(0, visibleWidth);
        let totalArea = rect.width * rect.height;

        let announcementBarVisions =  totalArea > 0 ? areaVisible / totalArea : 0;

        if (!header && !announcementBar) return

        if (header) {
          space = space + header.offsetHeight;
        }

        if (announcementBar) {
          space = space + (announcementBar.offsetHeight * announcementBarVisions);
        }

        this.style = `max-height: calc(100dvh-${space}px); top: ${space}px;`
      }
    }
  );
}

},{}]},{},[1])

